(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const icon = direction => direction === 'previous'
    ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4 7 12l8 8"/></svg>'
    : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 4 8 8-8 8"/></svg>';
  const mount = gallery => {
    if (!mobile.matches || gallery.dataset.norgiraRangerGallery === 'true') return;
    const slides = gallery.querySelector('slideshow-slides');
    const controls = [...gallery.querySelectorAll('.slideshow-controls__dots .slideshow-control')];
    if (!slides || controls.length < 2) return;
    gallery.dataset.norgiraRangerGallery = 'true';
    const nav = document.createElement('div');
    nav.className = 'norgira-pdp-gallery-nav';
    nav.innerHTML = '<button type="button" aria-label="Previous product image">'+icon('previous')+'</button><button type="button" aria-label="Next product image">'+icon('next')+'</button>';
    const select = offset => {
      const current = Math.max(0, controls.findIndex(button => button.getAttribute('aria-selected') === 'true'));
      controls[(current + offset + controls.length) % controls.length].click();
    };
    nav.querySelector('[aria-label^="Previous"]').addEventListener('click', () => select(-1));
    nav.querySelector('[aria-label^="Next"]').addEventListener('click', () => select(1));
    gallery.append(nav);
    // Match the collection-card interaction: a light tap on the product image advances one image.
    // Arrow controls and native horizontal swiping remain available.
    gallery.addEventListener('click', event => {
      if (!mobile.matches || event.target.closest('.norgira-pdp-gallery-nav')) return;
      if (!event.target.closest('slideshow-slide')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      select(1);
    }, true);
  };
  const refresh = () => document.querySelectorAll('main media-gallery').forEach(mount);
  refresh();
  new MutationObserver(refresh).observe(document.documentElement, {childList:true, subtree:true});
  mobile.addEventListener?.('change', refresh);
})();
